import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { useCallback } from 'react';
import { copyText } from 'utils/common';
import { SentryService } from 'utils/SentryService';
import { useClient } from 'ui-hooks/useClient';

export const useCopyText = () => {
  const { isApp } = useClient();

  return useCallback(
    async (text: string) => {
      if (isApp) {
        DirittoAppBridge.copyText(text);
      } else {
        try {
          await copyText(text);
        } catch (e) {
          SentryService.captureException(e);
          throw e;
        }
      }
    },
    [isApp],
  );
};
